import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid, TextField, Box, Typography } from '@mui/material';
import * as CONST from '../../../../constants/FieldsConst';
import {
  savePeriodosAcademicosAction,
  setActivoPeriodosAcademicosAction,
} from '../PeriodosAcademicosAction';
import { validMessage } from '../../../../constants/ValidsFormConst';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { EstatusField, LoadingWidget } from '../../../../widgets';
import { useNotification } from '../../../../helpers/Notification';

const FormPeriodosAcademicos = ({ isDelete = false }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const periodosAcademicosStore = Redux.useSelector(
    (state) => state.periodosAcademicos,
  );

  const activo = isDelete ? null : periodosAcademicosStore.activo;

  const initData = {
    nombre: '',
    desde: '',
    hasta: '',
    idEstatus: 1,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    nombre: false,
    desde: false,
    hasta: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    setData({
      ...values,
      idEstatus: activo.estatus?.id ?? 1,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (!entidadesStore.activo) {
      notify('Falta seleccionar la entidad', { warning: true });
      return;
    }
    if (_validDataForm()) {
      setLoadingSave(true);
      let res = await savePeriodosAcademicosAction(
        { dispatch, notify },
        activo?.id,
        {
          ...data,
          idEntidad: entidadesStore.activo.id,
          desde: Number(data.desde),
          hasta: Number(data.hasta),
        },
        periodosAcademicosStore.params,
      );
      if (res) clearData();
      setLoadingSave(false);
    }
  };

  function clearData() {
    setActivoPeriodosAcademicosAction(dispatch, null);
    setData(initData);
  }

  return (
    <Box component="form" sx={{ m: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          <Typography variant="h6">
            {activo ? 'Editar período' : 'Crear'}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.desde.name}
            required
            label={CONST.desde.label}
            value={data.desde}
            onChange={(e) =>
              _handleSetDataField(CONST.desde.name, e.target.value)
            }
            helperText={dataError.desde ? validMessage.required : null}
            error={dataError.desde}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.hasta.name}
            required
            label={CONST.hasta.label}
            value={data.hasta}
            onChange={(e) =>
              _handleSetDataField(CONST.hasta.name, e.target.value)
            }
            helperText={dataError.hasta ? validMessage.required : null}
            error={dataError.hasta}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.nombre.name}
            required
            label={CONST.nombre.label}
            value={data.nombre}
            onChange={(e) =>
              _handleSetDataField(
                CONST.nombre.name,
                e.target.value.toUpperCase(),
              )
            }
            helperText={dataError.nombre ? validMessage.required : null}
            error={dataError.nombre}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <EstatusField
            value={data.idEstatus}
            onChange={(e) =>
              _handleSetDataField(CONST.estatus.idName, e.target.value)
            }
            isEstatus
          />
        </Grid>
        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            disabled={loadingSave}
            green={!activo}
            blue={activo}
            mr={2}
            saveIcon
          />
          {activo && (
            <BotonComponent
              click={clearData}
              text="CANCELAR"
              disabled={loadingSave}
              black
              closeIcon
            />
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormPeriodosAcademicos;
